let _jurFiltroRapido='';
function jurFiltroRapido(val){
  _jurFiltroRapido=val;
  document.querySelectorAll('[id^="jur-chip-"]').forEach(b=>b.classList.remove('active'));
  const chipMap={'':'todos','processo':'processo','contrato':'contrato','licenca':'licenca','obrigacao':'obrigacao','notificacao':'notificacao','__vencidos':'vencidos','__proximos':'proximos','__ativos':'ativos','__arquivados':'arquivados'};
  const chip=document.getElementById('jur-chip-'+(chipMap[val]||'todos'));
  if(chip)chip.classList.add('active');
  renderJuridico();
}

function jurPrazoProximo(j){
  const prazosArr=(j.prazos||[]).filter(p=>p.data&&p.status!=='cumprido');
  const all=[...prazosArr.map(p=>p.data),j.prazo].filter(Boolean).sort();
  return all[0]||null;
}

function renderJuridico(){
  const busca=(document.getElementById('jur-search')?.value||'').trim().toLowerCase();
  const catF=document.getElementById('jur-filter-categoria')?.value||'';
  const statusF=document.getElementById('jur-filter-status')?.value||'';
  const riscoF=document.getElementById('jur-filter-risco')?.value||'';
  const todos=DB.get('juridico');
  const td=today(),em7=addDays(td,7),em30=addDays(td,30);
  const ativos=todos.filter(j=>!jurStatusIsFinal(j.status));
  const vencidos=ativos.filter(j=>{const p=jurPrazoProximo(j);return p&&p<td});
  const proximos7=ativos.filter(j=>{const p=jurPrazoProximo(j);return p&&p>=td&&p<=em7});
  const proximos30=ativos.filter(j=>{const p=jurPrazoProximo(j);return p&&p>=td&&p<=em30});
  const contingencia=ativos.reduce((s,j)=>s+(parseFloat(j.valorExposicao||j.valorCausa||j.valor)||0),0);
  const provisionado=ativos.reduce((s,j)=>s+(parseFloat(j.valorProvisionado)||0),0);
  const semResponsavel=ativos.filter(j=>!j.responsavel).length;
  const criticos=ativos.filter(j=>j.risco==='critico').length;

  // KPI Cards — ESTADO NEUTRO quando não há registros (nenhum verde positivo sem dados)
  if(!todos.length){
    document.getElementById('jur-cards').innerHTML=`
      <div class="card" style="grid-column:1/-1;background:var(--surface);border:1px dashed var(--border)">
        <div style="text-align:center;padding:8px 0">
          <i class="ti ti-scale" style="font-size:28px;color:var(--muted);display:block;margin-bottom:8px"></i>
          <div style="font-size:14px;font-weight:600;color:var(--muted)">Nenhum registro jurídico ou de compliance cadastrado</div>
          <div style="font-size:12px;color:var(--muted);margin-top:4px">A situação de regularidade ainda não foi verificada no sistema.</div>
          <button class="btn btn-primary btn-sm" style="margin-top:12px" onclick="openJuridicoForm()">+ Cadastrar primeiro registro</button>
        </div>
      </div>`;
  } else {
    document.getElementById('jur-cards').innerHTML=`
      <div class="card accent" onclick="jurFiltroRapido('__ativos')" style="cursor:pointer"><label>Registros ativos</label><div class="val">${ativos.length}</div><small style="color:var(--muted)">${todos.length} total</small></div>
      <div class="card ${vencidos.length?'red':'accent'}" onclick="jurFiltroRapido('__vencidos')" style="cursor:pointer"><label>Prazos vencidos</label><div class="val">${vencidos.length}</div><small style="color:var(--muted)">Ação imediata</small></div>
      <div class="card ${proximos7.length?'warn':'accent'}" onclick="jurFiltroRapido('__proximos')" style="cursor:pointer"><label>Próx. 7 dias</label><div class="val">${proximos7.length}</div><small style="color:var(--muted)">${proximos30.length} em 30 dias</small></div>
      <div class="card ${criticos?'red':'accent'}" style="cursor:pointer" onclick="document.getElementById('jur-filter-risco').value='critico';renderJuridico()"><label>Riscos críticos</label><div class="val">${criticos}</div><small style="color:var(--muted)">Revisão urgente</small></div>
      <div class="card purple"><label>Contingência estimada</label><div class="val">${fmt(contingencia)}</div><small style="color:var(--muted)">Provisionado: ${fmt(provisionado)}</small></div>
      ${semResponsavel?`<div class="card red" title="Registros sem responsável definido"><label>Sem responsável</label><div class="val">${semResponsavel}</div></div>`:''}`;
  }

  // Aplicar filtro rápido
  let lista=todos;
  if(_jurFiltroRapido==='__vencidos')lista=vencidos;
  else if(_jurFiltroRapido==='__proximos')lista=ativos.filter(j=>{const p=jurPrazoProximo(j);return p&&p<=em30});
  else if(_jurFiltroRapido==='__ativos')lista=ativos;
  else if(_jurFiltroRapido==='__arquivados')lista=todos.filter(j=>jurStatusIsFinal(j.status));
  else if(_jurFiltroRapido&&!_jurFiltroRapido.startsWith('__'))lista=todos.filter(j=>jurGrupoDaCategoria(j.categoria)===_jurFiltroRapido);

  // Aplicar filtros avançados
  if(catF)lista=lista.filter(j=>j.categoria===catF);
  if(statusF==='__ativos')lista=lista.filter(j=>!jurStatusIsFinal(j.status));
  else if(statusF==='__finais')lista=lista.filter(j=>jurStatusIsFinal(j.status));
  else if(statusF)lista=lista.filter(j=>j.status===statusF);
  if(riscoF)lista=lista.filter(j=>(j.risco||'baixo')===riscoF);
  if(busca)lista=lista.filter(j=>[j.titulo,j.numero,j.parte,j.orgao,j.responsavel,j.escritorio,j.cnpj,j.proximaAcao,j.obs].join(' ').toLowerCase().includes(busca));

  lista.sort((a,b)=>{
    const af=jurStatusIsFinal(a.status),bf=jurStatusIsFinal(b.status);
    if(af!==bf)return af?1:-1;
    const pa=jurPrazoProximo(a)||'9999-12-31',pb=jurPrazoProximo(b)||'9999-12-31';
    return pa.localeCompare(pb);
  });

  const el=document.getElementById('jur-list');
  if(!lista.length){
    el.innerHTML=`<div class="panel" style="text-align:center;padding:36px;color:var(--muted)">
      <i class="ti ti-search" style="font-size:32px;display:block;margin-bottom:10px"></i>
      Nenhum registro encontrado para os filtros atuais.
    </div>`;
    return;
  }

  el.innerHTML=lista.map(j=>{
    const prazo=jurPrazoInfo(j);
    const isFinal=jurStatusIsFinal(j.status);
    const corBorda=jurRiscoCor(j.risco||'baixo');
    const badgeCls=jurRiscoBadge(j.risco||'baixo');
    const valorTotal=parseFloat(j.valorExposicao||j.valorCausa||j.valor)||0;
    const valorProv=parseFloat(j.valorProvisionado)||0;
    // Prazos extras
    const prazosArr=(j.prazos||[]).filter(p=>p.data&&p.status!=='cumprido');
    const prazosHtml=prazosArr.slice(0,3).map(p=>{
      const d=Math.round((new Date(p.data+'T12:00:00')-new Date(today()+'T12:00:00'))/86400000);
      const cor=d<0?'var(--red)':d<=7?'var(--warn)':'var(--muted)';
      return `<span style="font-size:11px;color:${cor};margin-right:8px">📅 ${escapeHtml(p.titulo||'Prazo')}: ${fmtD(p.data)}</span>`;
    }).join('');
    return `
    <div class="panel" style="margin-bottom:10px;padding:16px;border-left:4px solid ${corBorda};opacity:${isFinal?'.7':'1'}">
      <div style="display:flex;justify-content:space-between;gap:14px;align-items:flex-start;flex-wrap:wrap">
        <div style="min-width:220px;flex:1">
          <div style="display:flex;gap:6px;align-items:center;flex-wrap:wrap;margin-bottom:6px">
            <span class="badge b-${badgeCls}">${escapeHtml(JUR_RISCOS[j.risco||'baixo'])}</span>
            <span class="badge">${escapeHtml(JUR_CATEGORIAS[j.categoria]||j.categoria||'Jurídico')}</span>
            <span class="badge">${escapeHtml(JUR_STATUS[j.status]||j.status||'Aberto')}</span>
            ${j.confidencialidade&&j.confidencialidade!=='interno'?`<span class="badge" style="background:rgba(239,68,68,.15);color:var(--red)">🔒 ${escapeHtml(JUR_CONFIDENCIALIDADE[j.confidencialidade]||j.confidencialidade)}</span>`:''}
          </div>
          <div style="font-size:15px;font-weight:750">${escapeHtml(j.titulo||'Sem título')}</div>
          <div style="font-size:12px;color:var(--muted);margin-top:4px">
            ${j.numero?`Nº ${escapeHtml(j.numero)} · `:''}${escapeHtml(j.parte||j.orgao||'')}
            ${j.escritorio?` · <em>${escapeHtml(j.escritorio)}</em>`:''}
          </div>
          ${prazosHtml?`<div style="margin-top:8px">${prazosHtml}</div>`:''}
          ${j.proximaAcao?`<div style="font-size:12px;margin-top:8px;padding:6px 10px;background:var(--surface);border-radius:6px;border-left:3px solid var(--accent)">
            <strong>Próxima ação${j.proximaAcaoTipo?` · ${escapeHtml(j.proximaAcaoTipo)}`:''}:</strong> ${escapeHtml(j.proximaAcao)}
            ${j.proximaAcaoData?`<span style="color:var(--muted);margin-left:6px">${fmtD(j.proximaAcaoData)}</span>`:''}
          </div>`:''}
        </div>
        <div style="min-width:170px;text-align:right">
          <div style="font-weight:700;font-size:14px;color:${prazo.classe==='red'?'var(--red)':prazo.classe==='warn'?'var(--warn)':'var(--text)'}">${escapeHtml(prazo.texto)}</div>
          <div style="font-size:11px;color:var(--muted);margin-top:3px">Resp.: ${escapeHtml(j.responsavel||'Não definido')}</div>
          ${valorTotal?`<div style="font-size:12px;margin-top:5px;font-weight:600">${fmt(valorTotal)}</div>${valorProv?`<div style="font-size:11px;color:var(--muted)">Provisionado: ${fmt(valorProv)}</div>`:''}`:''}
          <div style="display:flex;justify-content:flex-end;gap:5px;margin-top:10px;flex-wrap:wrap">
            ${j.documento?`<button class="btn btn-ghost btn-sm" onclick="abrirJurDocumento('${j.id}')" aria-label="Abrir documento" title="Abrir documento"><i class="ti ti-folder-open"></i></button>`:''}
            <button class="btn btn-ghost btn-sm" onclick="openJuridicoForm('${j.id}')">Editar</button>
            ${!isFinal?`<button class="btn btn-ghost btn-sm" onclick="jurEncerrar('${j.id}')">Encerrar</button>`:''}
            <button class="btn btn-danger btn-sm" onclick="deleteJuridico('${j.id}')">✕</button>
          </div>
        </div>
      </div>
    </div>`;
  }).join('');
}

// Prazos dinâmicos no modal
let _jurPrazos=[];
function jurRenderPrazos(){
  const c=document.getElementById('jur-prazos-container');if(!c)return;
  c.innerHTML=_jurPrazos.map((p,i)=>`
    <div style="display:flex;gap:8px;align-items:flex-start;margin-bottom:8px;padding:10px;background:var(--surface);border-radius:8px;border:1px solid var(--border)">
      <div class="form-grid" style="flex:1;margin:0;gap:8px;grid-template-columns:2fr 1fr 1fr auto">
        <input class="si" placeholder="Título do prazo *" value="${escapeHtml(p.titulo||'')}" oninput="_jurPrazos[${i}].titulo=this.value">
        <input type="date" class="si" value="${p.data||''}" oninput="_jurPrazos[${i}].data=this.value">
        <input class="si" placeholder="Responsável" value="${escapeHtml(p.responsavel||'')}" oninput="_jurPrazos[${i}].responsavel=this.value">
        <label style="display:flex;align-items:center;gap:4px;font-size:12px;white-space:nowrap;cursor:pointer">
          <input type="checkbox" ${p.status==='cumprido'?'checked':''} onchange="_jurPrazos[${i}].status=this.checked?'cumprido':'pendente'"> Cumprido
        </label>
      </div>
      <button type="button" class="btn btn-danger btn-sm" style="padding:4px 8px;flex-shrink:0" onclick="_jurPrazos.splice(${i},1);jurRenderPrazos()">✕</button>
    </div>`).join('')||'<div style="color:var(--muted);font-size:12px;padding:4px 0;margin-bottom:8px">Nenhum prazo adicional cadastrado.</div>';
}
function jurAdicionarPrazo(){_jurPrazos.push({id:uid(),titulo:'',data:'',responsavel:'',status:'pendente'});jurRenderPrazos()}

function jurAtualizarStatus(){
  const cat=document.getElementById('jur-categoria')?.value||'judicial';
  const sel=document.getElementById('jur-status');if(!sel)return;
  const atual=sel.value;
  const opts=jurStatusOptions(cat);
  sel.innerHTML=Object.entries(opts).map(([v,l])=>`<option value="${v}">${l}</option>`).join('');
  if(opts[atual])sel.value=atual;
  // Atualizar placeholders contextuais
  const g=jurGrupoDaCategoria(cat);
  const parteLabel=document.getElementById('jur-parte-label'),orgaoLabel=document.getElementById('jur-orgao-label');
  if(parteLabel)parteLabel.textContent=g==='contrato'?'Contraparte':g==='licenca'?'Órgão emissor':g==='obrigacao'?'Norma / requisito':'Parte contrária';
  if(orgaoLabel)orgaoLabel.textContent=g==='processo'?'Tribunal / vara / entidade':g==='contrato'?'Número / referência':g==='licenca'?'Tipo de licença':g==='obrigacao'?'Órgão regulador':'Órgão / entidade';
}

function openJuridicoForm(id=''){
  const j=id?DB.get('juridico').find(x=>x.id===id):null;
  document.getElementById('jur-modal-title').innerHTML=`${j?'Editar':'Novo'} registro jurídico <button class="modal-close" onclick="closeModal('modal-juridico')">×</button>`;
  const set=(idEl,val='')=>{const el=document.getElementById(idEl);if(el)el.value=val??''};
  set('jur-id',j?.id||'');
  set('jur-categoria',j?.categoria||'judicial');
  set('jur-risco',j?.risco||'baixo');
  set('jur-confidencialidade',j?.confidencialidade||'interno');
  set('jur-titulo',j?.titulo||'');
  set('jur-numero',j?.numero||'');
  set('jur-parte',j?.parte||'');
  set('jur-orgao',j?.orgao||'');
  set('jur-responsavel',j?.responsavel||'');
  set('jur-escritorio',j?.escritorio||'');
  set('jur-cnpj',formatCNPJ(j?.cnpj||(CACHE.config||{}).cnpj||''));
  set('jur-valor-causa',j?.valorCausa||j?.valor||'');
  set('jur-valor-exposicao',j?.valorExposicao||'');
  set('jur-valor-provisionado',j?.valorProvisionado||'');
  set('jur-valor-pago',j?.valorPago||'');
  set('jur-probabilidade',j?.probabilidade||'');
  set('jur-documento',j?.documento||'');
  set('jur-proxima-acao',j?.proximaAcao||'');
  set('jur-proxima-acao-tipo',j?.proximaAcaoTipo||'');
  set('jur-proxima-acao-data',j?.proximaAcaoData||'');
  set('jur-proxima-acao-resp',j?.proximaAcaoResp||'');
  set('jur-obs',j?.obs||'');
  // Prazos múltiplos
  _jurPrazos=JSON.parse(JSON.stringify(j?.prazos||[]));
  jurRenderPrazos();
  // Atualizar status dinamicamente conforme a categoria
  jurAtualizarStatus();
  if(j?.status){const sel=document.getElementById('jur-status');if(sel)sel.value=j.status}
  // Botões de ação contextual
  const btnArq=document.getElementById('jur-btn-arquivar');
  const btnEnc=document.getElementById('jur-btn-encerrar');
  if(btnArq)btnArq.style.display=j&&!jurStatusIsFinal(j.status)?'':'none';
  if(btnEnc)btnEnc.style.display=j&&!jurStatusIsFinal(j.status)?'':'none';
  // Timeline (auditoria)
  const tl=document.getElementById('jur-timeline');
  if(tl&&j){
    const hist=(CACHE.auditoria||[]).filter(a=>a.colecao==='juridico'&&a.docId===j.id).slice(-6).reverse();
    if(hist.length){
      tl.style.display='';
      tl.innerHTML=`<div style="font-size:11px;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:.5px;margin-bottom:6px">Histórico</div>`+
        hist.map(h=>`<div style="font-size:11.5px;color:var(--muted);padding:4px 0;border-top:1px solid var(--border)">${new Date(h.data||h.createdAt).toLocaleString('pt-BR',{dateStyle:'short',timeStyle:'short'})} · ${escapeHtml(h.acao)} · ${escapeHtml(h.desc||'')}</div>`).join('');
    }else{tl.style.display='none'}
  }else if(tl){tl.style.display='none'}
  openModal('modal-juridico');
}

async function saveJuridico(){
  const id=document.getElementById('jur-id').value;
  const titulo=document.getElementById('jur-titulo').value.trim();
  const responsavel=document.getElementById('jur-responsavel').value.trim();
  if(!titulo){toast('Informe o título / assunto do registro.','error');return}
  if(!responsavel){toast('Informe o responsável interno.','error');return}
  const lista=DB.get('juridico');
  const antes=id?lista.find(x=>x.id===id):null;
  const get=el=>document.getElementById(el)?.value?.trim()||'';
  const item={
    id:id||uid(),
    categoria:get('jur-categoria')||'judicial',
    status:get('jur-status')||'aberto',
    risco:get('jur-risco')||'baixo',
    confidencialidade:get('jur-confidencialidade')||'interno',
    titulo,
    numero:get('jur-numero'),
    parte:get('jur-parte'),
    orgao:get('jur-orgao'),
    responsavel,
    escritorio:get('jur-escritorio'),
    cnpj:formatCNPJ(get('jur-cnpj')),
    valorCausa:parseFloat(get('jur-valor-causa'))||0,
    valorExposicao:parseFloat(get('jur-valor-exposicao'))||0,
    valorProvisionado:parseFloat(get('jur-valor-provisionado'))||0,
    valorPago:parseFloat(get('jur-valor-pago'))||0,
    // Campo legado para retrocompatibilidade com badges/alertas existentes
    valor:parseFloat(get('jur-valor-exposicao'))||parseFloat(get('jur-valor-causa'))||0,
    probabilidade:get('jur-probabilidade'),
    documento:get('jur-documento'),
    proximaAcao:get('jur-proxima-acao'),
    proximaAcaoTipo:get('jur-proxima-acao-tipo'),
    proximaAcaoData:get('jur-proxima-acao-data'),
    proximaAcaoResp:get('jur-proxima-acao-resp'),
    obs:get('jur-obs'),
    prazos:_jurPrazos.filter(p=>p.titulo||p.data),
    createdAt:antes?.createdAt||new Date().toISOString(),
    updatedAt:new Date().toISOString(),
    _version:antes?._version
  };
  const idx=lista.findIndex(x=>x.id===item.id);if(idx>=0)lista[idx]=item;else lista.unshift(item);
  await DB.set('juridico',lista);
  await auditar(id?'editar':'criar','juridico',`${id?'Editou':'Criou'} ${JUR_CATEGORIAS[item.categoria]||item.categoria}: ${item.titulo}`,antes,item);
  closeModal('modal-juridico');renderJuridico();renderDashboard();updateBadges();toast('Registro jurídico salvo ✓');
}

async function jurEncerrar(id,status='encerrado'){
  const lista=DB.get('juridico'),antes=lista.find(x=>x.id===id);if(!antes)return;
  const resultado=status==='encerrado'?await uiPrompt({eyebrow:'Jurídico',title:`Encerrar “${antes.titulo}”`,message:'Registre o desfecho para preservar o contexto jurídico e facilitar consultas futuras.',label:'Resultado do encerramento',type:'textarea',value:'Encerrado sem pendências',confirmLabel:'Encerrar registro'}):null;
  if(status==='encerrado'&&resultado===null)return;
  const idx=lista.findIndex(x=>x.id===id);
  lista[idx]={...lista[idx],status,resultado:resultado||'',updatedAt:new Date().toISOString()};
  await DB.set('juridico',lista);
  await auditar('editar','juridico',`Encerrou registro jurídico: ${antes.titulo}`,antes,lista[idx]);
  renderJuridico();updateBadges();toast('Registro encerrado ✓');
}
async function jurArquivar(id){return jurEncerrar(id,'arquivado')}
function jurEncerrarDoModal(){const id=document.getElementById('jur-id').value;if(id){closeModal('modal-juridico');jurEncerrar(id)}}
function jurArquivarDoModal(){const id=document.getElementById('jur-id').value;if(id){closeModal('modal-juridico');jurArquivar(id)}}

async function deleteJuridico(id){
  const antes=DB.get('juridico').find(x=>x.id===id);if(!antes||!await uiConfirm({tone:'danger',eyebrow:'Registro jurídico',title:`Excluir “${antes.titulo}”?`,message:'Encerrar ou arquivar é a opção recomendada quando o fato precisa permanecer consultável.',impact:'A exclusão remove o registro jurídico; a ação ficará registrada na auditoria.',confirmLabel:'Excluir registro'}))return;
  await DB.remove('juridico',id);await auditar('excluir','juridico',`Excluiu registro jurídico ${antes.titulo}`,antes,null);renderJuridico();updateBadges();toast('Registro excluído');
}

function abrirJurDocumento(id){
  const j=DB.get('juridico').find(x=>x.id===id);if(!j?.documento)return;
  const path=j.documento.trim();const pasta=/\.[a-z0-9]{2,6}$/i.test(path)?path.replace(/\/[^/]+$/,''):path;
  showPage('documentos');setTimeout(()=>dbxListFolder(pasta),100);
}

// ===================================================
// MÁQUINAS & MANUTENÇÃO
// ===================================================
// MÁQUINAS & MANUTENÇÃO
// renderManutencao/openMaquinaForm/openManutencaoForm e demais helpers exclusivos da pagina movidos para page-manutencao.js

